<template>
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="date"
                append-icon="mdi-calendar"
                readonly
                v-bind="{...attrs, ...$attrs}"
                v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker v-model="date" @input="menu = false"></v-date-picker>
    </v-menu>
</template>

<script>
export default {
    props: {
        value: String
    },
    data() {
        return {
            menu: false, 
            date: this.value
        }
    },
    watch: {
        date(value) {
            this.$emit("input", value)
        }
    }
};
</script>

<style>
</style>